const routes = [
  {
    path: '/topup-histories/:workspace_id',
    name: 'Topup Histories',
    meta: { layout: 'dashboard', auth: true },
    component: () => import('../ui/pages/topup/AllHistories.vue'),
  },
];
export default routes;
